import { routes } from 'routes';
import { GATEWAY_TYPE } from './constants';

export const getTabOptions = (translate) => {
    const tabsOptions = [
        {
            title: translate('ABB.Powertrain.Frontend.gatewayManagementDrives'),
            route: routes.GatewayManagementConnectedAssetsDrives
        },
        {
            title: translate('ABB.Powertrain.Frontend.gatewayManagementEnvironmentSensor'),
            route: routes.GatewayManagementConnectedAssetsEnvironmentSensor,
        }
    ];

    return tabsOptions;
};

export const MAX_SEARCH_LENGTH = 50;

export const isIOTGatewayType = (selectedGateway) => selectedGateway?.gatewayType === GATEWAY_TYPE.DCP;
export const isEdgeGatewayType = (selectedGateway) => selectedGateway?.gatewayType === GATEWAY_TYPE.EGW02;
export const isCassiaOrArubaGatewayType = (selectedGateway) =>
    selectedGateway?.gatewayType === GATEWAY_TYPE.CASSIA || selectedGateway?.gatewayType === GATEWAY_TYPE.ARUBA || selectedGateway?.gatewayType === GATEWAY_TYPE.MACH_SENSE_R;
